<template>
    <div class="form-control listbox">
        <label v-for="(s, i) in items" :key="i">
            <input type="checkbox" :checked="value.indexOf(i) >= 0" :value="i" @change="change">
            <slot name="item" :item="s"></slot>
        </label>
    </div>
</template>
<script>
export default {
    name: 'checkedListBox',
    props: {
        value: {
            type:Array,
            default: function () {
                return [];
            }
        },
        items: {
            type: Object,
            default: function(){
                return {};
            }
        }
    },
    methods: {
        change(event){
            console.log('change:', event.target.checked);
            if(event.target.checked)
                this.value.push(event.target.value);
            else
                this.value.splice(this.value.indexOf(event.target.value), 1);// = this.value.filter(x => x != event.target.value);
        }
    }
}
</script>
<style scoped>
.listbox {
    height:120px;
    padding: 4px 8px;
    overflow-y:auto;
}

.listbox > label {
    display:block; margin-bottom:0
} 

.listbox > label > input {
    margin-right: 8px;
}
</style>